export default "__VITE_ASSET__7e4c6ab3__"